import App from '@components/sliders/SpaceMultipleSkuCarousel.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';

const axios = generateAxiosInstance();
const injections = [{
        name: 'locale',
        module: locale
    },{
        name: '$axios',
        module: generateAxiosInstance()
    }]
const props = { 
    product,
    variations
}
generateApplication(App, "#spaces_mutiple_skus", { injections, props })